import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IListResponse } from "common/models/GridModels";
import { PostModel } from "common/models/BaseModel";
import {
  IEntryExitDashboardFilter,
  IEntryExitDashboardSummary,
  IEntryExitDashboardCharts,
  ICurrentlyInsideItem,
  ICurrentlyInsideGridFilter,
  IEntryExitDashboardLogItem,
  IEntryExitDashboardLogGridFilter,
} from "./types";

export const entryExitDashboardKeys = createQueryKeys("entryExitDashboard", {
  summary: (filter: IEntryExitDashboardFilter) => ({
    queryKey: [filter, "summary"],
    queryFn: () =>
      api.post<IEntryExitDashboardSummary>(
        endpoints.dashboard.entryExitSummary,
        filter
      ),
  }),

  charts: (filter: IEntryExitDashboardFilter) => ({
    queryKey: [filter, "charts"],
    queryFn: () =>
      api.post<IEntryExitDashboardCharts>(
        endpoints.dashboard.entryExitCharts,
        filter
      ),
  }),

  currentlyInside: (postModel: PostModel<ICurrentlyInsideGridFilter>) => ({
    queryKey: [postModel, "currentlyInside"],
    queryFn: () =>
      api.post<IListResponse<ICurrentlyInsideItem>>(
        endpoints.dashboard.currentlyInside,
        postModel
      ),
  }),

  logs: (postModel: PostModel<IEntryExitDashboardLogGridFilter>) => ({
    queryKey: [postModel, "logs"],
    queryFn: () =>
      api.post<IListResponse<IEntryExitDashboardLogItem>>(
        endpoints.dashboard.entryExitLogs,
        postModel
      ),
  }),
});
